module.exports = "https://coinrabbit.io/_next/static/images/rabbit-83db89929e416a20c97c2a6fa3d049b0.svg";